import { useQuery } from "@tanstack/react-query";
import { getDocument } from "../services/document.service";
import { IDocument } from "../types/document.types";
import { getDocumentInfo } from "../utils/document.utils";
import * as React from "react";

export const useDocument = () => {
  const [msWordId, setMsWordId] = React.useState<string | null>(null);

  React.useEffect(() => {
    const loadDocumentInfo = async () => {
      try {
        const docInfo = await getDocumentInfo();
        if (docInfo.id != null) {
          setMsWordId(docInfo.id);
        }
      } catch (error) {
        console.error("Failed to load document info:", error);
      }
    };

    loadDocumentInfo();
  }, []);

  return useQuery<IDocument>({
    queryKey: ["document", msWordId],
    queryFn: () => getDocument(msWordId ?? ""),
    enabled: msWordId != null,
    retry: false, // Don't retry on 404, we'll handle it manually
  });
};
